export default __webpack_public_path__ + "static/media/bacqueville14.6e5a6221.jpg";